<template>
    <component
        :is="currentComponent"
        v-if="currentComponent"
        v-bind="$props"
        ref="StripeCardVersionChild"
    />
</template>
<script>

export default {
    name: 'StripeCard',
    components: {
        v1: async () => await import('./v1/StripeCard'),
        v2: async () => await import('./v2/StripeCard')
    },
    props: {
        version: {
            type: String,
            default: null
        },
        email: {
            type: String,
            required: true,
        },
        planName: {
            type: String,
            required: true,
        },
        amount: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
        },
        subscriptionPeriod: {
            type: Number,
            default: 0
        }
    },
    data: () => ({}),
    computed: {
        currentComponent() {
            //TODO: ComponentVersions affect other modules (Agents & Brokers). Implement a way to either load configs for each or one config to set versions
            return this.version || 'v1';//this.$componentsVersion[this.$options.name] || 'v1';
        },
    },
    methods: {
        async sendPayment(isPublic = false) {
            return await this.$refs.StripeCardVersionChild.sendPayment(isPublic);
        }
    }
}
</script> 